import api from '../../../configs/instanceApi';

export const getParameterization = async (parameterizationType) => {
  const url = `/accreditation-quotations/parameterizations/${parameterizationType}`;
  return api.get(url);
};
